import { ValidationError } from "sequelize"
import { MtTag, MtTagCreate, MtTagSave } from "server/models"
import { OrderType } from "client/utils"
import { GET, POST, DELETE, sort, validate } from "client/store/utils"
import { LangType } from "client/store"
import {
    TagList,
    TagValidation,
    TagFilters,
} from "./types"


export const LoadAllTags = () => (
    GET("/mtTag/all")
    .then((tags: MtTag[]) => {
        const tagList: TagList = {}
        const tagUniqueList: { [key: string]: MtTag } = {}

        tags.forEach((tag) => {
            tagList[tag.id] = tag
            const tagId = DeleteTagSpaces(tag.name.toUpperCase())
            tagUniqueList[tagId] = tag
        })

        return { tagList, tagUniqueList }
    })
)

const Save = (data: MtTagSave, lang: LangType) => (
    POST(
        "/mtTag/save",
        JSON.stringify(data),
    ).then((res) => {
        const newTag = res as MtTag
        const error = res as ValidationError
        return {
            newTagId: newTag.id || null,
            validation: <TagValidation>validate(error, lang),
        }
    })
)

export const SaveTag = (
    id: number,
    tag: MtTagCreate,
    lang: LangType,
) => {
    const data: MtTagSave = {
        id,
        tag,
    }

    return LoadAllTags().then((res1) => {
        const tagId = DeleteTagSpaces(tag.name.toUpperCase())
        const existingTag = res1.tagUniqueList[tagId]

        if (existingTag && existingTag.id !== id) {
            return {
                newTagId: null,
                validation: { name: lang.validationNotUnique },
            }
        }

        return Save(data, lang)
    })
}

export const CreateManyTags = (
    tags: string[],
    lang: LangType,
) => {
    const tagIds: number[] = []
    const promiseArray: Promise<any>[] = []

    return LoadAllTags().then((tagListResponse) => {
        tags.forEach((tagName) => {
            const existingTagId = DeleteTagSpaces(tagName.toUpperCase())
            const existingTag = tagListResponse.tagUniqueList[existingTagId]

            if (existingTag) tagIds.push(existingTag.id)
            else {
                const data: MtTagSave = {
                    id: null,
                    tag: {
                        name: tagName.trim(),
                    },
                }
                promiseArray.push(
                    Save(data, lang).then((res) => {
                        if (res.newTagId) tagIds.push(res.newTagId)
                    }),
                )
            }
        })

        return Promise.all(promiseArray).then(() => tagIds)
    })
}

export const DeleteTag = (tagId: number) => (
    DELETE(`/mtTag/delete/${tagId}`)
    .then((removedRows: number) => removedRows)
)

export const SortTags = (
    tags: MtTag[],
    sortColumn: keyof MtTag,
    sortOrder: OrderType,
    filters: TagFilters,
) => {
    const tagsFiltered = tags.filter((tag) => {
        let showRow = true
        if (filters.search) {
            const searchString = DeleteTagSpaces(tag.name.toUpperCase())
            const pattern = DeleteTagSpaces(filters.search.toUpperCase())
            showRow = searchString.indexOf(pattern) >= 0
        }
        return showRow
    })
    tagsFiltered.sort((a, b) => sort(a, b, sortColumn, sortOrder))

    const tagIds: number[] = []
    tagsFiltered.forEach((tag) => tagIds.push(tag.id))

    return tagIds
}

export const DeleteTagSpaces = (tag: string) => (
    tag.split(" ").join("")
)
